// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6d364d93","455":"510c2376","977":"ffe26371"}[chunkId] + ".chunk.js";
};